import {Component} from "@angular/core";
import {ReportType} from "../../objects/report/reportType";
/**
 * Created by alex.y on 9/26/2017.
 */
@Component({
    selector: "report-total-fee-container",
    templateUrl: "./totalFeeReport.component.html",
    moduleId: module.id.toString()
})
export class TotalFeeReportComponent{
    public reportType = ReportType;
}



// WEBPACK FOOTER //
// ./app/components/reports/totalFeeReport.component.ts